import { Component, OnInit } from '@angular/core';
import { ApiResource } from '../../resources/api.resource';
import { ActivatedRoute, Params } from '@angular/router';

declare var $: any;
declare var $e: any;

const globalCenterMapLat = 13.6915591;
const globalCenterMapLng = -89.2497134;
const globalMapZoom = 12;

@Component({
  selector: 'app-seguros-personas',
  templateUrl: './seguros-personas.component.html',
  styleUrls: ['./seguros-personas.component.scss']
})
export class SegurosPersonasComponent implements OnInit {

  public HeaderHtml = null;
  public FooterHtml = null;
  public menuHeaderHtml = null;
  public menuFooterHtml = null;
  public BotonesDeSlides = null;
  public sliderHtml = null;
  public tabsHtml = null;
  public responseUuid = null;
  public productsHtml = null;
  public customHtml = null;
  public habilitarPaginaBuscar = false;
  public formulario=null;
  public mapa={};

  constructor(private resource: ApiResource, private rutaActiva: ActivatedRoute) { }

  ngOnInit() {

    localStorage.setItem("componenteActual",'seguros-personas');

console.log('seguros-personas---->buscarHacia--->'+localStorage.getItem("buscarHacia"));

if(localStorage.getItem("buscarHacia") === 'seguros-personas'){

  this.obtenerPagina(localStorage.getItem("uuidBuscar"));  
  localStorage.setItem("buscarHacia",'');
  
  }else{
    if (this.rutaActiva.snapshot.params.uuid) {
      this.obtenerPagina(this.rutaActiva.snapshot.params.uuid);
    }
    else {
      this.obtenerPagina("portal_principal_personas_seguros");
    }

  }

    
  }

  public obtenerPagina(uuid): any {

    this.habilitarPaginaBuscar = true;
    this.sliderHtml = null;
    this.BotonesDeSlides = null;
    this.tabsHtml = null;
    this.responseUuid = null;
    this.productsHtml = null;
    this.customHtml=null;
    this.sliderHtml = null;

    this.habilitarPaginaBuscar=false;
    this.resource.obtenerHtmlPorUUID(uuid).subscribe(
      (resp) => {
        console.warn("resp", resp);
        this.responseUuid = resp;

        //verificar si viene formulario
        if (resp.details.formulario) {
          this.formulario = resp.details.formulario;
        }
        else {
          this.formulario = null;
        }
        
        
        for(let web of resp.elementos_web){
          if(web.posicion=='Pre-Header'){
            this.HeaderHtml = web;
          }
          else if(web.posicion=='Footer'){
            this.FooterHtml = web;
          }
        }

        this.menuFooterHtml = resp.elementos_footer;
        this.menuHeaderHtml = this.crearRowParaContenidoDeMenu(resp.menu);


        // la pagina es de tipo custom
        if (resp.details.tabs == null && resp.details.products==null && resp.details.slides == null ) {
          this.customHtml = resp.details;
          console.warn("custom");
        }
        else {
          this.customHtml = null;
        }

        // la pagina es de tipo slides
        if (resp.details.slides != null) {
          this.BotonesDeSlides = this.crearBotonesDeSlides(resp.details.slides);
          this.sliderHtml = this.procesarSlides(resp.details.slides);
        }
        else {
          this.BotonesDeSlides = null;
          this.sliderHtml = null;
        }




        //la pagina es de tipo tabs
        if (resp.details.tabs != null) {
          this.tabsHtml = resp.details;
        }
        else {
          this.tabsHtml = null;
        }


        //la pagina es de tipo producs
        if (resp.details.products != null) {
          this.productsHtml = resp.details;
        }
        else {
          this.productsHtml = null;
        }



        this.initFullpage();
        $(".c-body").removeClass("overflow-hidden");
      }
    );
  }

  private procesarSlides(slides) {
    for (let slide of slides) {
      slide.titulo = slide.titulo.split('|');
    }
    return slides;
  }


  private initFullpage() {
    const $el = document.querySelector('#test-c');

    if ($el) {
      const html = `
      <script>
        var innerMap, innerMarkers = [];
        var globalCenterMapLat = ${globalCenterMapLat},
            globalCenterMapLng = ${globalCenterMapLng},
            globalMapZoom = ${globalMapZoom};

        if (!window.startIntro) {
          window.startIntro = true;
        }

        setTimeout(function () {
          if ($.fn.fullpage.destroy) {
            $.fn.fullpage.destroy('all');
          }

          setTimeout(function () {
            $('#fullpage').fullpage({
              // anchors: ['uno', 'dos', 'tres', 'cuatro'],
              menu: '#myMenu',
              scrollingSpeed: 1000,
              autoScrolling: true,
              scrollOverflow: true,
              resize: false,
              keyboardScrolling: false,
              afterRender: function () {
                var $map = document.getElementById('inner-map');
                var $items = $('#myMenu li');
                var $next = $('#fp-id-1');

                $items.removeClass('custom-class-active');
                $next.addClass('example custom-class-active');

                if ($map) {
                  innerMap = new google.maps.Map($map, {
                    center: {lat: globalCenterMapLat, lng: globalCenterMapLng},
                    disableDefaultUI: true,
                    zoom: globalMapZoom
                  });

                  var marker = new google.maps.Marker({
                    position: {lat: globalCenterMapLat, lng: globalCenterMapLng},
                    map: innerMap,
                    title: 'Hello World!'
                  });

                  innerMarkers.push(marker);
                }
              },
              onLeave: function(index, nextIndex, direction) {
                var $items = $('#myMenu li');
                var $next = $('#fp-id-'+nextIndex);

                $items.removeClass('custom-class-active');
                $next.addClass('custom-class-active');
              }
            });
          }, 100);
        }, 75);
      </script>
      `;

      const fragment = document.createRange().createContextualFragment(html);
      $el.appendChild(fragment);
    }
  }

  private crearRowParaContenidoDeMenu(array) {
    let i, j, tempArray = [], chunk = 4;
    let innerArray = [];
    for (i = 0, j = array.length; i < j; i++) {
      if (array[i].html_icon !== '-' && array[i].descripcion !== ' ' && array[i].descripcion !== '') {
        innerArray.push(array[i]);
      }
    }
    for (i = 0, j = innerArray.length; i < j; i += chunk) {
      tempArray.push(innerArray.slice(i, i + chunk));
    }
    return tempArray;
  }

  private crearBotonesDeSlides(slides) {
    let nav = '';
    let eventsMove = '';

    slides.map(({ html_icon, nombre }, index) => {
      const counter = index + 1;
      const selector = `fp-id-${counter}`;

      nav += `
        <li id="${selector}" ${index == 0 ? ' class="custom-class-active"' : ''}>
          <a href="#">
            <i class="icono ${html_icon}"></i><span class="text">${nombre}</span>
          </a>
        </li>`;

      eventsMove += `
        $('body').on('click', '#${selector}', function (event) {
          event.stopPropagation();
          $.fn.fullpage.moveTo(${counter});
        });
      `;
    });

    $('#test-c').append(`<script>${eventsMove}</script>`);

    return nav;
  }

  public buscar(buscar) { 
    this.sliderHtml = null;
    this.BotonesDeSlides = null;
    this.sliderHtml = null;
    this.tabsHtml = null;
    this.responseUuid = null;
    this.productsHtml = null;
    this.customHtml=null;
    
    this.habilitarPaginaBuscar = true;
  }





}
